<script lang="ts">

    export let primary = false;
    export let secondary = false;
    export let large = false;
    export let href = '';
    export let maxWidth = '';

    let primaryIcon = 'icons/icon_top_more3.svg';
    let secondaryIcon = 'icons/icon_top_more2.svg';
    const style = () => {
        let _style = '';
        _style = `background-image: url('${primary ? primaryIcon : secondaryIcon}');`;
        _style += maxWidth ? `max-width: ${maxWidth};` : ``;

        return _style;
    }

</script>

<a href={href}
   class='button'
   class:primary
   class:secondary
   class:large
   style={style()}
>
    <slot></slot>
</a>